import React, { useEffect, useState } from "react";
import "./SignUpPage.css";
import AuthLeftSection, { handleDownloadGoogleAppClick, handleDownloadAppleAppClick } from "../../Components/Shared/AuthLeftSection/AuthLeftSection";
import { useDispatch, useSelector } from "react-redux";
import { setActiveComponent } from "../../Redux/Slices/activeComponentSlice";
import EnterMobileNumber from "../../Components/SignUpFlow/EnterMobileNumber/EnterMobileNumber";
import MobileOtpVerification from "../../Components/SignUpFlow/MobileOtpVerification/MobileOtpVerification";
import EnterEmail from "../../Components/SignUpFlow/EnterEmail/EnterEmail";
import EmailOtpVerification from "../../Components/SignUpFlow/EmailOtpVerification/EmailOtpVerification";
import EmailPassword from "../../Components/SignUpFlow/EmailPassword/EmailPassword";
import EnterName from "../../Components/SignUpFlow/EnterName/EnterName";
import EnterPersonalDetails from "../../Components/SignUpFlow/EnterPersonalDetails/EnterPersonalDetails";
import EnterAddress from "../../Components/SignUpFlow/EnterAddress/EnterAddress";
import FaceRecognition from "../../Components/FaceRecognition/FaceRecognition";
import SignUpSuccessfull from "../../Components/SignUpFlow/SignUpSuccessfull/SignUpSuccessfull";
import { getToken, getUserId } from "../../api/index";
import { useNavigate } from "react-router-dom";
import { getRedirectPath, storeRedirectPath, clearRedirectPath } from "../../utils/authRedirect";

const VALID_SIGN_UP_COMPONENTS = [
    "enterMobileNumber",
    "mobileOtpVerification",
    "enterEmail",
    "emailOtpVerification",
    "emailPassword",
    "enterName",
    "enterPersonalDetails",
    "enterAddress",
    "faceRecognition1",
    "signUpSuccessfull"
];

const SignUpPage = () => {
    const dispatch = useDispatch();
    const activeComponent = useSelector((state) => state.activeComponent.activeComponent);
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        storeRedirectPath();
        // Only set default step if nothing explicit or valid has been chosen yet
        if (!activeComponent || !VALID_SIGN_UP_COMPONENTS.includes(activeComponent)) {
            dispatch(setActiveComponent("enterMobileNumber"));
        }
    }, [activeComponent, dispatch]);

    // Handle authentication redirect - but not during signup success flow
    useEffect(() => {
        if (getToken() && getUserId() && activeComponent !== "signUpSuccessfull") {
            const target = getRedirectPath();
            clearRedirectPath();
            navigate(target, { replace: true });
        }
    }, [activeComponent, navigate]);

    useEffect(() => {
        const checkIsMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkIsMobile();
        window.addEventListener('resize', checkIsMobile);

        return () => {
            window.removeEventListener('resize', checkIsMobile);
        };
    }, []);

    const handleBackClick = () => {
        if (activeComponent === "mobileOtpVerification") {
            dispatch(setActiveComponent("enterMobileNumber"));
        }
         if (activeComponent === "enterEmail") {
            dispatch(setActiveComponent("enterMobileNumber"));
        }
        else if (activeComponent === "enterMobileNumber") {
            dispatch(setActiveComponent("getStarted"));
        }
        else if (activeComponent === "emailOtpVerification") {
            dispatch(setActiveComponent("enterEmail"));
        }
        else if (activeComponent === "emailPassword") {
            dispatch(setActiveComponent("emailOtpVerification"));
        }
        else if (activeComponent === "enterName") {
            dispatch(setActiveComponent("emailPassword"));
        }
        else if (activeComponent === "enterPersonalDetails") {
            dispatch(setActiveComponent("enterName"));
        }
        else if (activeComponent === "enterAddress") {
            dispatch(setActiveComponent("enterPersonalDetails"));
        }
        else if (activeComponent === "faceRecognition1") {
            dispatch(setActiveComponent("enterAddress"));
        }
    }

    console.log("activeComponent", activeComponent);

    return (
        <div className="LandingPage">
            <div className="landingPageContainer">
                <AuthLeftSection />
                <div className="landingRightSection">
                    {activeComponent !== "enterMobileNumber" && (
                        <span className="backBtnContainer" onClick={handleBackClick}>
                            <img
                                src="/Assets/LandingPage/backArrow.svg"
                                alt="no img found"
                                className="backBtnIcon"
                            />
                            <span className="backBtnText">Back</span>
                        </span>
                    )}
                    
                    {/* Mobile Logo at top */}
                    {isMobile && (
                        <div 
                            className="mobileLogoContainer" 
                            onClick={() => navigate('/')} 
                            style={{ cursor: 'pointer' }}
                            title="Return to Amalgamate Home"
                        >
                            <img
                                className="mobileAmalgamateLogo"
                                src="/Assets/LandingPage/AmalgamateLogo.svg"
                                alt="Amalgamate Logo"
                            />
                        </div>
                    )}
                    
                    <div className="landingRightSectionContainer">
                        {
                            (!activeComponent || activeComponent === "enterMobileNumber" || !VALID_SIGN_UP_COMPONENTS.includes(activeComponent)) && (
                                <EnterMobileNumber />
                            )
                        }
                        {
                            activeComponent === "mobileOtpVerification" && (
                                <MobileOtpVerification />
                            )
                        }
                        {
                            activeComponent === "enterEmail" && (
                                <EnterEmail />
                            )
                        }
                        {
                            activeComponent === "emailOtpVerification" && (
                                <EmailOtpVerification />
                            )
                        }
                        {
                            activeComponent === "emailPassword" && (
                                <EmailPassword />
                            )
                        }
                        {
                            activeComponent === "enterName" && (
                                <EnterName />
                            )
                        }
                        {
                            activeComponent === "enterPersonalDetails" && (
                                <EnterPersonalDetails />
                            )
                        }
                        {
                            activeComponent === "enterAddress" && (
                                <EnterAddress signUp={true}/>
                            )
                        }
                        {
                            activeComponent === "faceRecognition1" && (
                                <FaceRecognition isUserVerified={'verified'} />
                            )
                        }
                        {
                            activeComponent === "signUpSuccessfull" && (
                                <SignUpSuccessfull />
                            )
                        }
                       
                    </div>
                    
                    {/* Mobile Download Cards at bottom */}
                    {isMobile && (
                        <div className="mobileDownloadSection">
                            <div className="mobileGetTheAppContainer">
                                <div className="mobileFadingLine1"></div>
                                <span className="mobileGetTheAppText">Get The App</span>
                                <div className="mobileFadingLine2"></div>
                            </div>
                            <div className="mobileDownloadAppCards">
                                <div className="mobileDownloadAppCardContainer">
                                    <div className="mobileDownloadAppCard" onClick={handleDownloadGoogleAppClick}>
                                        <img
                                            src="/Assets/LandingPage/playStoreIcon.svg"
                                            alt="no img found"
                                            className="mobileDownloadAppCardIcon"
                                        />
                                        <div className="mobileDownloadAppCardTextContainer">
                                            <span className="mobileDownloadAppCardText1">Get it on</span>
                                            <span className="mobileDownloadAppCardText2">
                                                Google Play
                                            </span>
                                        </div>
                                    </div>
                                    <div className="mobileDownloadAppCard" onClick={handleDownloadAppleAppClick}>
                                        <img
                                            src="/Assets/LandingPage/appStoreIcon.svg"
                                            alt="no img found"
                                            className="mobileDownloadAppCardIcon2"
                                        />
                                        <div className="mobileDownloadAppCardTextContainer">
                                            <span className="mobileDownloadAppCardText1">
                                                Get it on
                                            </span>
                                            <span className="mobileDownloadAppCardText2">App Store</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SignUpPage;